class _UserAgent {
    public static instance: _UserAgent;
    public userAgent: string;

    constructor() {
        this.userAgent = navigator.userAgent.toLowerCase();
    }

    static get Instance() {
        if (!_UserAgent.instance) {
            _UserAgent.instance = new _UserAgent();
        }
        return _UserAgent.instance;
    }

    // 判断是否为 H5 环境
    isH5 = (): boolean =>
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(this.userAgent);

    // 判断是否为 PC 环境
    isPC = (): boolean => !this.isH5();

    // 判断是否在 Google Chrome 浏览器中
    isGoogleChrome = (): boolean =>
        this.userAgent.includes('chrome') && !this.userAgent.includes('edge');

    // 判断是否在苹果手机上
    isAppleMobile = (): boolean => /iphone|ipad|ipod/i.test(this.userAgent);

    // 判断是否在苹果默认浏览器（Safari）中
    isAppleDefaultBrowser() {
        //return this.userAgent.includes('safari') && !this.userAgent.includes('chrome');
        // 核心判断条件
        const hasVersion = /version\/\d+\.\d+/.test(this.userAgent);
        const isSafari = /safari\/\d+/.test(this.userAgent);
        // 排除其他浏览器
        const notChrome = !/crios\/\d+/.test(this.userAgent);
        const notQQ = !/mqqbrowser\/\d+/.test(this.userAgent);
        const notFirefox = !/fxios\/\d+/.test(this.userAgent);
        const notEdge = !/edgios\/\d+/.test(this.userAgent);
        return (
            this.isAppleMobile() &&
            hasVersion &&
            isSafari &&
            notChrome &&
            notQQ &&
            notFirefox &&
            notEdge &&
            !this.useInAppBrowser()
        );
    }

    isFacebookAppBrowser = (): boolean => /(fban|fbav|fbsv)/i.test(this.userAgent);
    isInstagramAppBrowser = (): boolean => /(instagram|ig_iab)/i.test(this.userAgent);
    isTwitterAppBrowser = (): boolean => /(twitter|twi_iab)/i.test(this.userAgent);
    isTikTokAppBrowser = (): boolean => /(tiktok|musically)/i.test(this.userAgent);
    isTelegramAppBrowser = (): boolean => /(telegram|webapp)/i.test(this.userAgent);
    isLinkedInAppBrowser = (): boolean => /(linkedin|li_iab)/i.test(this.userAgent);
    isKwaiInAppBrowser = (): boolean => /(kwai|kwai-browser)/i.test(this.userAgent);
    isWhatsappInAppBrowser = (): boolean => /whatsapp/i.test(this.userAgent);
    isSharechatappInAppBrowser = (): boolean => /sharechat/i.test(this.userAgent);
    isSnapchatappInAppBrowser = (): boolean => /snapchat/i.test(this.userAgent);
    isMXPlayerappInAppBrowser = (): boolean => /mxplayer/i.test(this.userAgent);
    isYoutubeappInAppBrowser = (): boolean => /youtube|yt/i.test(this.userAgent);

    useInAppBrowser = (): boolean =>
        this.isFacebookAppBrowser() ||
        this.isInstagramAppBrowser() ||
        this.isTwitterAppBrowser() ||
        this.isTikTokAppBrowser() ||
        this.isTelegramAppBrowser() ||
        this.isLinkedInAppBrowser() ||
        this.isKwaiInAppBrowser() ||
        this.isWhatsappInAppBrowser() ||
        this.isSharechatappInAppBrowser() ||
        this.isSnapchatappInAppBrowser() ||
        this.isMXPlayerappInAppBrowser() ||
        this.isYoutubeappInAppBrowser();
    // 判断是否为 iPhone 全面屏机型（带 Home Indicator）
    isiPhoneWithHomeIndicator() {
        // 仅 iOS 设备
        if (!this.isAppleMobile()) return false;
        try {
            // 获取屏幕高宽比
            const ratio = window.screen.height / window.screen.width;
            // iPhone 全面屏的高宽比特征（近似值）
            const isIPhoneX = Number(ratio.toFixed(2)) >= 2.16 && Number(ratio.toFixed(2)) <= 2.18; // iPhone X/XS/11 Pro
            const isIPhoneXR = Number(ratio.toFixed(2)) >= 2.1 && Number(ratio.toFixed(2)) <= 2.12; // iPhone XR/11
            const isIPhoneMax =
                Number(ratio.toFixed(2)) >= 2.05 && Number(ratio.toFixed(2)) <= 2.07; // iPhone XS Max/11 Pro Max/12-15 Pro Max
            const isIPhone12Mini =
                Number(ratio.toFixed(2)) >= 2.16 && Number(ratio.toFixed(2)) <= 2.17; // iPhone 12/13 mini
            const isIPhoneStandard =
                Number(ratio.toFixed(2)) >= 2.16 && Number(ratio.toFixed(2)) <= 2.17; // iPhone 12-15 标准版
            return isIPhoneX || isIPhoneXR || isIPhoneMax || isIPhone12Mini || isIPhoneStandard;
        } catch (e) {
            return true;
        }
    }

    isIosSafari(): boolean {
        const ua = window.navigator.userAgent;
        const isIOS = /iP(hone|od|ad)/.test(ua);
        const isWebkit = /WebKit/.test(ua);
        const isSafari = !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua); // 排除 Chrome、Firefox、Opera、Edge 等 iOS 浏览器

        return isIOS && isWebkit && isSafari;
    }

    openSafari(url: string) {
        //var openUrl = `x-web--search://?${'https://www.baidu.com'}`;
        //var openUrl = `x-safari-https://${url}`;
        var openUrl = `x-safari-${url}`;
        window.location.assign(openUrl);
    }

    /**
     * Open Android default browser
     * @param url
     * @param bool force  true 强制使用包名为 `com.android.chrome` 的应用打开链接，false 使用系统默认浏览器打开链接
     */
    openAndroidDefaultBrowser(url: string, force: boolean = false) {
        var scheme = 'https';
        var urlWithoutProtocol = url;
        if (/^https:\/\//i.test(url)) {
            urlWithoutProtocol = url.replace(/^https:\/\//i, '');
            scheme = 'https';
        } else if (/^http:\/\//i.test(url)) {
            urlWithoutProtocol = url.replace(/^http:\/\//i, '');
            scheme = 'http';
        }
        const packageOrComponent = force ? 'package' : 'component';
        const openUrl = `intent://${urlWithoutProtocol}#Intent;scheme=${scheme};action=android.intent.action.VIEW;${packageOrComponent}=com.android.chrome;end`;
        window.location.assign(openUrl);
    }
}

export let UserAgent = _UserAgent.Instance;
